import { render, staticRenderFns } from "./imgTextItem.vue?vue&type=template&id=4bbdcd9b&"
import script from "./imgTextItem.vue?vue&type=script&lang=js&"
export * from "./imgTextItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports